window.onclick = async () => {
  let cart_k = await fetch("/cart.js");
  let data_k = await cart_k.json();
  let items = data_k.items;
  items.forEach((e) => {
    if (e.sku.includes("NVD")) {
      if (e.quantity > 1) {
       location.reload();
      }
    }
  });
};
